export enum AgreementsOverduePaymentsModeType {
	MAIN_DEBT = "MAIN_DEBT",
	INTEREST = "INTEREST"
}
